module.exports = __webpack_public_path__ + "media/Kathryn.e95e2a55.mp4";